module.exports = __webpack_public_path__ + "img/flora_trialset_202307.020bc7b3.jpg";